import { MenuButton } from '@szhsin/react-menu';
import styled, { css } from 'styled-components';

export const StyledAgentProfile = styled.div`
  width: 100%;

  .head {
    display: flex;
    gap: 24px;
    border-bottom: 1px solid rgb(229, 231, 235);
    padding-bottom: 30px;
    margin-bottom: 40px;

    .img-box {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      overflow: hidden;
      background-color: rgba(248, 198, 48, 0.1);
      background-position: 0% 0%;
      background-repeat: repeat;
      color: rgb(2, 8, 23);
      height: 100px;
      width: 100px;
      outline: var(--primary) dashed 1px;
      box-shadow:
        rgb(255, 255, 255) 0px 0px 0px 0px,
        rgba(7, 134, 43, 0.4) 0px 0px 0px 4px,
        rgba(0, 0, 0, 0) 0px 0px 0px 0px;
      border-radius: 16px;

      @media (min-width: 768px) {
        height: 128px;
        width: 128px;
      }

      img {
        width: 100%;
        height: auto;
        display: block;
        object-fit: cover;
      }
    }

    .name {
      display: block;
      font-size: 28px;
      line-height: 32px;
      font-weight: 700;
      margin-bottom: 16px;

      @media (min-width: 768px) {
        font-size: 36px;
        line-height: 40px;
      }
    }

    .description {
      display: block;
      font-size: 16px;
      line-height: 20px;
      font-weight: 300;
      margin-bottom: 16px;

      @media (min-width: 768px) {
        font-size: 18px;
        line-height: 22px;
      }
    }

    .time {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 10px;
      font-size: 14px;
      line-height: 18px;
      font-weight: 300;

      @media (min-width: 768px) {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }

  .row {
    @media (min-width: 992px) {
      display: flex;
      gap: 16px;
    }

    .col {
      width: 100%;
    }

    .col-2 {
      width: 100%;
      @media (min-width: 992px) {
        max-width: 400px;
      }
    }
  }
`;

export const CardHolder = styled.div`
  border: 1px solid rgb(229, 231, 235);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 20px;
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 20px;
    border-bottom: 1px solid rgb(229, 231, 235);
    background-color: #19191b;

    .card-title {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 20px;
      font-weight: 600;
      line-height: 28px;
    }

    .total-memories {
      text-transform: capitalize;
      font-size: 14px;
      line-height: 18px;
      font-weight: 500;
      padding: 5px 10px;
      border-radius: 16px;
      border: 1px solid rgba(157, 157, 157, 0.3);
    }
  }

  ${({ $noBodyPadding }) =>
    !$noBodyPadding &&
    css`
      .card-details {
        padding: 20px;
      }
    `}

  .memory {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    padding: 14px 20px;
    background-color: #19191b;
    border-radius: 12px;
    border: 1px solid rgba(157, 157, 157, 0.3);
    margin-bottom: 10px;
    .memory-heading {
      display: block;
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      margin-bottom: 10px;
      width: 100%;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      @media (min-width: 576px) {
        max-width: 600px;
      }
    }
    .memory-date {
      font-size: 14px;
      line-height: 18px;
      font-weight: 400;
    }
    .category-wrap {
      position: relative;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;
      @media (min-width: 576px) {
        flex-wrap: nowrap;
      }
      .category {
        text-transform: capitalize;
        font-size: 14px;
        line-height: 18px;
        font-weight: 400;
        padding: 5px 10px;
        border-radius: 16px;
        border: 1px solid rgba(157, 157, 157, 0.3);
      }
    }

    .icon-wrap {
      display: flex;
      align-items: center;
      gap: 12px;
      cursor: pointer;
    }
  }

  .tool-name {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    text-transform: capitalize;
    background-color: #19191b;
    border-radius: 8px;
    padding: 10px;
    border: 1px solid rgb(229, 231, 235);
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0 !important;
    }
  }

  .list-wrap {
    li {
      padding: 20px;
      border-bottom: 1px solid rgb(229, 231, 235);

      .li-title {
        display: block;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        margin-bottom: 10px;
      }

      .li-value {
        text-transform: capitalize;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;

        &.enabled {
          font-size: 12px;
          line-height: 16px;
          font-weight: 600;
          background-color: rgba(34, 197, 94, 0.1);
          color: rgb(21, 128, 61);
          border-radius: 9999px;
          padding: 6px 8px;
        }
        &.disabled {
          font-size: 12px;
          line-height: 16px;
          font-weight: 600;
          background-color: rgba(239, 68, 68, 0.1);
          color: rgb(185, 28, 28);
          border-radius: 9999px;
          padding: 6px 8px;
        }
      }

      &:last-child {
        border-bottom: 0;
      }
    }
  }
`;

export const MenuBtn = styled(MenuButton)`
  position: relative;
`;
